import { useAuthCookies } from 'hooks/authCookies';
import type { FC } from 'react';
import { createContext } from 'react';

export interface CommonUtilsContextData {
  isLiveSpinsAvailable: boolean;
}

export const CommonUtilsContext = createContext<CommonUtilsContextData>(
  null as any
);

export const CommonUtilsContextProvider: FC = ({ children }) => {
  useAuthCookies();

  const isLiveSpinsAvailable = false;

  return (
    <CommonUtilsContext.Provider
      value={{
        isLiveSpinsAvailable,
      }}
    >
      {children}
    </CommonUtilsContext.Provider>
  );
};
